<template>
 <div >
     <img src="../assets//11.png" style="height:350px;width:100%;" alt=""  />
     <div>
    <el-card id="box-cardn" >
        <div slot="header" >
            <span style="color:white;">公司动态</span>
        </div>
        <div v-for="(item,index) in articlelist" :key="index" class="text item">
            <!-- <router-link to="/fund" id="text"><a href="#">基金介绍</a></router-link> -->
            <!-- <a :href="'/active/activelist/'+item.id">{{item.title}}</a> -->
            <router-link :to="'/active/activelist/'+item.id" id="text" ><a href="#">{{item.title}}</a></router-link>
            <hr>
        </div>
    </el-card>
    <div class="control-center">
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="queryInfo.pagenum"
      :page-size="100"
      layout="prev, pager, next, jumper"
      :total="500">
    </el-pagination>
    </div>
</div>
     <!-- <Intro3></Intro3> -->

 </div>
</template>

<script>
import Divider2 from '../components/divider2.vue'
import News from '../components/news.vue'
import Cardshow2 from '../components/cardshow2.vue'
import Intro3 from '../components/intro3.vue'
import bus from '../assets/bus.js'

export default {
 components:{
     Divider2,
     News,
     Cardshow2,
     Intro3,
     bus
 },
 data() {
      return {
        id:19,
        articlelist:[],
        queryInfo: {
        title: '',
        type: '新闻中心',
        pagenum: parseInt(this.$route.path.replace('/active/','')),
        pagesize: 15,
      },
      };
    },
    watch: {
    $route (to, from) {
      if (to.path.replace('/active/','')!=this.queryInfo.pagenum) {
        // console.log(to.path.replace('/investment/',''))
        this.queryInfo.pagenum = to.path.replace('/active/','')
        this.getarticlelist()
      }
    }
  },
    created(){
      this.getarticlelist()
      


    },
    
    methods: {
      handleSizeChange(val) {
        this.queryInfo.pagesize = val
        console.log(`每页 ${val} 条`);
        this.getarticlelist()
      },
      handleCurrentChange(val) {
        console.log(`当前页: ${val}`);
        this.queryInfo.pagenum = val
        console.log(this.queryInfo.pagenum)
        this.$router.push('/active/'+val);
        this.getarticlelist()
      },
      handleChange(val) {
        console.log(val);
      },
      async getarticlelist(){
        const res =await this.$http.get('/huayin/get-articles',{params:this.queryInfo}
          )
        this.articlelist=res.data.data
        console.log(this.articlelist[0].id)
        
        
        bus.$emit('data1',this.articlelist[0].title)


      },
      // send(){
      //   bus.$emit('data',to.path.replace('/active/',''))
      //   console.log("build send")
      // }
    },
}
</script>
<style>
    
    .text {
    font-size: 14px;
    color: white;
  }

  .item {
    margin-bottom: 25px;
  }
  .text a{
    text-decoration: none;
    color:aliceblue;
  }
  .clearfix:before,
  .clearfix:after {
    display: table;
    content: "";
  }
  .clearfix:after {
    clear: both
  }

  #box-cardn {
    /* text-align: center; */
    width: 60%;
    height: 1000px;
    background-color:rgba(0,0,0,0.7);
    position: relative;
    /* margin-top: -100px; */
    /* margin-left: 100px; */
    margin: 0 auto;
    z-index: 9999;
  }
  .control-center{
    text-align: center;
  }
</style>



// WEBPACK FOOTER //
// src/pages/active.vue